import { marketingDetails } from './marketing'
import { serviceCategories } from './serviceCategories'
import { servicePages } from './servicePages'
import { getPreferredServicePath } from './servicePageContent'
import type { NavigationItem, ServiceCategoryId } from './types'

const labels: Record<string, string> = {
  'printing-copying': 'Copies & Printing',
  'document-finishing': 'Binding & Laminating',
  'ipostal1': 'Virtual Mailbox / iPostal1',
}

function categoryLinks(id: ServiceCategoryId): NavigationItem[] {
  const category = serviceCategories.find((item) => item.id === id)!
  return servicePages.filter((service) => service.enabled && service.categoryId === id).map((service) => ({
    label: labels[service.id] ?? service.name,
    href: getPreferredServicePath(service.id, `/services/${category.slug}/${service.slug}`),
  }))
}

export const utilityNavigation: readonly NavigationItem[] = [
  { label: 'Track Package', href: '/Tracking' },
  { label: 'Upload Files', href: '/file-upload' },
]

export const navigation: readonly NavigationItem[] = [
  { label: 'Copy & Print', href: '/services/copy-print', children: [
    { label: 'All Copy & Print Services', href: '/services/copy-print' },
    ...categoryLinks('copy-print'),
    { label: 'Upload Files', href: '/file-upload' },
    { label: 'Special Offers', href: '/coupons' },
  ] },
  { label: 'Shipping & Packing', href: '/services/shipping', children: [
    { label: 'Shipping Services', href: '/services/shipping' },
    ...categoryLinks('shipping'),
    { label: 'Packing Services', href: '/services/packing' },
    ...categoryLinks('packing'),
    { label: 'Track a Package', href: '/Tracking' },
  ] },
  { label: 'Business Services', href: '/services/home-business', children: [
    { label: 'All Business Services', href: '/services/home-business' },
    ...categoryLinks('home-business'),
  ] },
  { label: 'Marketing & Websites', href: '/digital-marketing', children: [
    { label: 'Digital Marketing', href: '/digital-marketing' },
    { label: 'Marketing Packages', href: '/digital-marketing/packages' },
    ...marketingDetails.map((detail) => ({ label: detail.slug === 'websites' ? 'Website Design & Hosting' : detail.slug === 'social-media' ? 'Social Media Marketing' : detail.title, href: `/digital-marketing/${detail.slug}` })),
    { label: 'Logo & Branding', href: '/digital-marketing/custom?service=Branding' },
    { label: 'Custom Quote', href: '/digital-marketing/custom' },
  ] },
  { label: 'About Us', href: '/about-us', children: [
    { label: 'About Pack Print Mail', href: '/about-us' },
    { label: 'Our Services', href: '/Store-Services' },
    { label: 'Partnership with Arina Technologies', href: '/partners/arina-technologies' },
  ] },
  { label: 'Contact', href: '/contact-us' },
]
